import { useMemo } from "react";

import FileCardButton from "../../../Components/UI/FileCardButton/FileCardButton";
import WatermarkTable from "./WatermarkTable";

const ResultsSection = ({ results, onOpenModal, onReset }) => {
  const { originalImage, deblurImage, enhancedImages, watermarks } = results;

  // Build the ordered image list used by the modal viewer:
  // [original?, deblur?, ...enhanced]
  const modalImages = useMemo(() => {
    const list = [];
    if (originalImage) list.push({ url: originalImage, description: "Original Image" });
    if (deblurImage) list.push({ url: deblurImage, description: "Deblurred Image (Enhanced)" });
    (enhancedImages || []).forEach((img) =>
      list.push({ url: img.url, description: img.description }),
    );
    return list;
  }, [originalImage, deblurImage, enhancedImages]);

  const mainImage = deblurImage || originalImage;
  const mainImageIndex = deblurImage ? (originalImage ? 1 : 0) : 0;

  const enhancedOffset = (originalImage ? 1 : 0) + (deblurImage ? 1 : 0);

  const openMain = () => {
    if (modalImages.length) onOpenModal(modalImages, mainImageIndex);
  };

  const openEnhanced = (index) => {
    onOpenModal(modalImages, enhancedOffset + index);
  };

  return (
    <div className="watermark-decoder__results">
      <div className="watermark-decoder__results__header">
        <h2>Analysis Results</h2>
        <FileCardButton onClick={onReset}>
          <p>New Analysis</p>
        </FileCardButton>
      </div>

      <div className="watermark-decoder__images-container">
        <div className="watermark-decoder__image-card border">
          <h3>
            {deblurImage ? (
              <>
                Deblurred Image <span className="watermark-decoder__enhanced-tag">(Enhanced)</span>
              </>
            ) : (
              "Original Image"
            )}
          </h3>
          <div className="watermark-decoder__image-viewer">
            {mainImage ? (
              <img src={mainImage} alt="Analyzed" onClick={openMain} />
            ) : (
              <div className="watermark-decoder__image-placeholder">No image</div>
            )}
          </div>
        </div>

        <div className="watermark-decoder__enhanced-images border">
          <h3>Enhanced Image Variants</h3>
          {enhancedImages && enhancedImages.length > 0 ? (
            <div className="watermark-decoder__enhanced-grid">
              {enhancedImages.map((img, index) => (
                <div
                  key={index}
                  className="watermark-decoder__enhanced-item"
                  onClick={() => openEnhanced(index)}>
                  <img src={img.url} alt={img.description} />
                  <div className="watermark-decoder__enhanced-item__label">{img.description}</div>
                </div>
              ))}
            </div>
          ) : (
            <p className="watermark-decoder__enhanced-empty">
              No enhanced image variants available.
            </p>
          )}
        </div>
      </div>

      <div className="watermark-decoder__table-container border">
        <h3>Detected Watermark Information</h3>
        <WatermarkTable watermarks={watermarks} />
      </div>
    </div>
  );
};

export default ResultsSection;
